import type FieldController from '../fields/Controller'
import type { FilterField } from '../fields/useFilterField'
import type { Localization } from '../types'

import React from 'react'

import { getCompatableValueType } from '../helpers'
import Combobox from './Combobox'

export default function ReferencePicker({
	locale,
	filterField,
	fields,
	isInvalid,
	...props
}: {
	locale: Localization
	filterField: FilterField
	fields: FieldController[]
	isInvalid: boolean
}) {
	const reference = filterField.getFilterReference()
	const compatableValueType = getCompatableValueType(
		filterField.getFilterOperation()
	)

	return (
		<Combobox
			locale={locale}
			value={reference}
			onChange={filterField.setFilterReference}
			name='field'
			className='w-full overflow-auto'
			placeholder={locale.getFieldPlaceholder()}
			invalid={isInvalid}
			options={fields
				.filter((f) => compatableValueType.includes(f.valueType))
				.map((field: FieldController) => ({
					label: field.label,
					value: field.key,
				}))}
			{...props}
		/>
	)
}
